var FactApiUrl = process.env.VUE_APP_FACTFIND_API_URL;
var CashFlowApiUrl = process.env.VUE_APP_API_URL;
var AdlSSOUrl = process.env.VUE_APP_SSO_URL;
var TemplateApiUrl = process.env.VUE_APP_TEMPLATE_URL;
export default {
  authApiUrl: FactApiUrl + "/Auth",
  liablityApiUrl: CashFlowApiUrl + "/v1/Liability",
  clientApiUrl: FactApiUrl + "/Client",
  iceLoanApiUrl: CashFlowApiUrl + "/v1/Calculate/Loan/Projection",
  iceApiUrl: CashFlowApiUrl + "/v1/Calculate/Projection",
  saveLoanApiUrl: CashFlowApiUrl + "/v1/Liability",
  saveInvestmentApiUrl: CashFlowApiUrl + "/v1/Investment",
  saveAsInvestmentApiUrl: CashFlowApiUrl + "/v1/Investment/SaveAs",
  saveUserEventApiUrl: CashFlowApiUrl + "/v1/UserEvent",
  saveUserSessionApiUrl: CashFlowApiUrl + "/v1/UserActivity/Log",

  saveAsLoanApiUrl: CashFlowApiUrl + "/v1/Liability/SaveAs",
  deleteLoanApiUrl: CashFlowApiUrl + "/v1/Liability",
  copyLoanApiUrl: CashFlowApiUrl + "/v1/Liability/Copy",
  copyInvestmentApiUrl: CashFlowApiUrl + "/v1/Investment/Copy",
  logError: CashFlowApiUrl + "/v1/Error/Log",
  engagementdashboardurl: CashFlowApiUrl + "/v1/Getengagementsummary",
  getAuthCodeUrl: AdlSSOUrl + "/auth/authorize",
  tokenVerifierUrl: AdlSSOUrl + "/auth/token",
  signInUrl: CashFlowApiUrl + "/v1/LogIn",
  investmentApiUrl: CashFlowApiUrl + "/v1/Investment",
  riskprofileurl: FactApiUrl + "/RiskProfile/1.0.19",
  saveSuperannuationApiUrl: CashFlowApiUrl + "/v1/Superannuation",
  saveAsSuperannuationApiUrl: CashFlowApiUrl + "/v1/Superannuation/SaveAs",
  copySuperannuationApiUrl: CashFlowApiUrl + "/v1/Superannuation/Copy",
  superannuationApiUrl: CashFlowApiUrl + "/v1/SuperAnnuation",
  deleteSuperannuationApiUrl: CashFlowApiUrl + "/v1/Superannuation",
  loanExcelFileDownLoadApiUrl: CashFlowApiUrl + "/v1/Report/Loan/Excel",
  loanPDFFileGenerateApiUrl:
    TemplateApiUrl + "/toc/DownloadEngageCalculatorReport",
  loanPDFFileDownLoadApiUrl: TemplateApiUrl + "/TOC/GetFile?fileName=",
};
